import {useInfiniteQuery, type InfiniteData} from "@tanstack/react-query";
import {sendHookRequest, type ApiError, type BackendAPIBlueprint} from "../generated/blueprint.ts";
import type {QueryKey} from "../api/queryKeys.ts";

export interface KeysetPage {
    next_cursor: string | null;
}

interface KeysetInfiniteQueryOptions<TParams extends object> {
    api: BackendAPIBlueprint;
    queryKey: QueryKey;
    path: string;
    params: TParams;
    pageSize: number;
}

export function useKeysetInfiniteQuery<TPage extends KeysetPage, TParams extends object>(
    {api, queryKey, path, params, pageSize}: KeysetInfiniteQueryOptions<TParams>,
) {
    return useInfiniteQuery<
        TPage,
        ApiError,
        InfiniteData<TPage, string | null>,
        readonly unknown[],
        string | null
    >({
        queryKey: [queryKey, path, params],
        initialPageParam: null,
        queryFn: ({pageParam, signal}) => sendHookRequest<TPage>(
            api,
            'get',
            path,
            {...params, cursor: pageParam, limit: pageSize},
            signal,
        ),
        getNextPageParam: (lastPage) => lastPage.next_cursor ?? undefined,
        refetchOnWindowFocus: false,
    });
}
